import BillingsOrderRelatedRailyTaxi from "../../../../../../../common/services/billings/order/related/raily-taxi/billings-order-related-raily-taxi";
import BillingModel from "../../../../../types/billing-model";
import RelatedRailyTaxiBillingData from "../types/related-raily-taxi-billing data";

const createBillingsData = (data: BillingsOrderRelatedRailyTaxi[]) => {
  const relatedBillings: RelatedRailyTaxiBillingData[] = data.map(
    (billingDataItem): RelatedRailyTaxiBillingData => {
      return {
        uuid: billingDataItem.cargoOrder.id,
        contractDetails: {
          companyName: billingDataItem.contract.taxiCorporation.companyName,
          distanceRate: billingDataItem.contract.distanceRate,
          model: billingDataItem.contract.model as BillingModel,
        },
        haltingCost: billingDataItem.haltingAmount,
        highwayCharge: billingDataItem.highwayCharge,
        distance: billingDataItem.distance,
        routeDistanceCost: billingDataItem.distanceAmount,
        internalOrderId: billingDataItem.cargoOrder.humanId,
        total: billingDataItem.totalAmount,
        date: billingDataItem.date,
        bonus: billingDataItem.bonus,
        penalty: billingDataItem.penalty,
      };
    },
  );

  return relatedBillings;
};

const relatedRailyTaxiBillingsDataFactory = {
  createBillingsData,
};

export default relatedRailyTaxiBillingsDataFactory;
